import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { TriangleIcon } from '@icons';
import classNames from 'classnames';
import React, { useMemo, useState } from 'react';
import { isDark } from '../common/utils';
import { DataGridCell } from './data-grid-cell';
import styles from './data-grid-header.module.scss';
import iconStyles from './data-grid-icons.module.scss';
const DataGridHeader = ({ columns = [], style, onSort, layoutStyle, border, size, searchable, }) => {
    const isDarkMode = useMemo(() => isDark(), []);
    const [headerColumns, setHeaderColumns] = useState(columns.map(col => ({
        ...col,
        sortDirection: 'asc',
    })));
    const handleSort = (column, dir) => {
        setHeaderColumns(columns => columns.map(col => ({
            ...col,
            sortDirection: col.name === column ? dir : 'none',
        })));
        onSort && onSort(column, dir);
    };
    const headerClass = useMemo(() => {
        return classNames(styles.header, {
            [styles[`${layoutStyle}`]]: true,
            [styles[`${size}`]]: true,
        });
    }, [layoutStyle]);
    const headerCellClass = useMemo(() => {
        return classNames(styles.cell, {
            [styles.border]: border,
            [styles.dark]: isDarkMode,
        }, searchable ? styles.searchable : '');
    }, []);
    return (_jsx("div", { className: headerClass, style: style, role: "row", children: headerColumns.map(column => (_jsxs("div", { className: headerCellClass, children: [_jsx(DataGridCell, { name: column.name, value: column.name, border: false, isHeader: true }), column.sortable && (_jsxs("span", { className: iconStyles.sort_icon_wrapper, children: [_jsx("span", { className: classNames(iconStyles.sort_icon_asc, {
                                [iconStyles.sort_icon_active]: column.sortDirection === 'asc',
                            }), role: "button", onClick: () => handleSort(column.name, 'asc'), children: _jsx(TriangleIcon, {}) }), _jsx("span", { className: classNames(iconStyles.sort_icon_desc, {
                                [iconStyles.sort_icon_active]: column.sortDirection === 'desc',
                            }), role: "button", onClick: () => handleSort(column.name, 'desc'), children: _jsx(TriangleIcon, {}) })] }))] }, column.name))) }));
};
DataGridHeader.displayName = 'DataGridHeader';
export { DataGridHeader };
